import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import { getCaregiverPatientsData, getPatientsByFacilityId } from './actions';
import { PatientTableItem, ValueOf } from 'types/types';
import { ViewMode, DataStatus } from 'types/enums';

type State = {
  status: ValueOf<typeof DataStatus>;
  data: PatientTableItem[];
  totalCount: number;
  monitoringFacilityId: string;
  patientsViewMode: ViewMode;
};

const initialState: State = {
  data: [],
  status: DataStatus.IDLE,
  totalCount: 0,
  monitoringFacilityId: '',
  patientsViewMode: ViewMode.IDLE,
};

const { reducer, actions } = createSlice({
  initialState,
  name: 'patients',
  reducers: {
    setMonitoringFacilityId(state, { payload }: PayloadAction<string>) {
      state.monitoringFacilityId = payload;
    },
    setPatientsViewMode(state, { payload }: PayloadAction<ViewMode>) {
      state.patientsViewMode = payload;
    },
  },
  extraReducers(builder) {
    builder.addMatcher(
      isAnyOf(getCaregiverPatientsData.fulfilled, getPatientsByFacilityId.fulfilled),
      (state, { payload }) => {
        state.status = DataStatus.SUCCEEDED;
        state.data = payload.patients;
        state.totalCount = payload.totalCount;
      },
    );
    builder.addMatcher(isAnyOf(getCaregiverPatientsData.pending, getPatientsByFacilityId.pending), (state) => {
      state.status = DataStatus.LOADING;
    });
    builder.addMatcher(isAnyOf(getCaregiverPatientsData.rejected, getPatientsByFacilityId.rejected), (state) => {
      state.status = DataStatus.FAILED;
    });
    builder.addMatcher(isAnyOf(getPatientsByFacilityId.rejected, getCaregiverPatientsData.rejected), (state) => {
      state.data = [];
      state.totalCount = 0;
    });
  },
});

export { actions, reducer };
